const showAddPaymentButton = {
    show: () => {
        jQuery(".show_clickable").show();
    },

    hide: () => {
        jQuery(".show_clickable").hide();
    },
};

export default showAddPaymentButton;
